import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const MobileBottomNav = () => {
  const location = useLocation();
  const { unreadCount } = useAuth();
  const [notificationCount] = useState(3);

  const navItems = [
    { path: '/member-dashboard', icon: 'Home', label: 'Home' },
    { path: '/class-schedule', icon: 'Calendar', label: 'Classes' },
    { path: '/events-calendar', icon: 'CalendarDays', label: 'Events' },
    { path: '/ai-coaching', icon: 'Bot', label: 'AI Coach' },
    { path: '/member-profile', icon: 'User', label: 'Profile' },
  ];

  const isActivePath = (path) => {
    if (path === '/workout-library') {
      return location?.pathname === '/workout-library' || location?.pathname === '/active-workout';
    }
    if (path === '/progress-analytics') {
      return location?.pathname === '/progress-analytics' || location?.pathname === '/nutrition-tracker';
    }
    if (path === '/class-schedule') {
      return location?.pathname === '/class-schedule' || location?.pathname === '/trainer-profiles';
    }
    if (path === '/social-leaderboards') {
      return location?.pathname === '/social-leaderboards';
    }
    if (path === '/member-chat-system') {
      return location?.pathname === '/member-chat-system';
    }
    if (path === '/challenge-system') {
      return location?.pathname === '/challenge-system';
    }
    return location?.pathname === path;
  };

  const hasNotification = (path) => {
    return path === '/class-schedule' && unreadCount > 0;
  };

  return (
    <nav 
      className="lg:hidden fixed bottom-0 left-0 right-0 z-[100] bg-card border-t border-border shadow-2xl"
      aria-label="Mobile navigation"
    >
      <div className="flex items-center justify-around h-16 px-2">
        {navItems?.map((item) => {
          const isActive = isActivePath(item?.path);
          const showNotification = hasNotification(item?.path);
          
          return (
            <Link
              key={item?.path}
              to={item?.path}
              className={`
                relative flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg
                min-w-[64px] transition-smooth press-scale
                ${isActive 
                  ? 'text-primary' :'text-muted-foreground'
                }
              `}
              aria-label={item?.label}
              aria-current={isActive ? 'page' : undefined}
            >
              <div className="relative">
                <Icon 
                  name={item?.icon} 
                  size={24} 
                  color={isActive ? 'var(--color-primary)' : 'currentColor'}
                  strokeWidth={isActive ? 2.5 : 2}
                />
                {showNotification && (
                  <span 
                    className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-accent"
                    aria-label={`${unreadCount} notifications`}
                  />
                )}
              </div>
              <span className={`text-[11px] font-medium caption ${isActive ? 'font-semibold' : ''}`}>
                {item?.label}
              </span>
              {isActive && (
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-8 h-1 bg-primary rounded-t-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;